import { IconLayer, ScatterplotLayer } from '@deck.gl/layers';

import { Optional } from '@angular/core';

import { SnAlarm } from '@lib/api/entities';
import { THEME_RGB_ARR } from '@lib/ui/theme';

import { AlarmsMarkerIconInterface } from './alarm-marker-icon';

export class AlarmWebGlMarkerLayer {
  private _iconLayer: IconLayer;
  private _scatterPlotLayer: ScatterplotLayer;

  private _icons: AlarmsMarkerIconInterface = {
    shotspotter: {
      fontIcon: 'Icon_ShotSpotter',
      fontSet: 'fs',
    },
    'shooter detection systems': {
      fontIcon: 'Icon_ShotSpotter',
      fontSet: 'fs',
    },
    'panic app': {
      fontIcon: 'Icon_Panic',
      fontSet: 'fs',
    },
    'rt alpr': {
      fontIcon: 'Icon_LPAR',
      fontSet: 'fs',
    },
    'vigilant learn alpr': {
      fontIcon: 'Icon_Vigilant',
      fontSet: 'fs',
    },
    'fs alpr': {
      fontIcon: 'Icon_FS',
      fontSet: 'fs',
    },
    'genetec alpr': {
      fontIcon: 'Icon_Genetec',
      fontSet: 'fs',
    },
    'rekor alpr': {
      fontIcon: 'Icon_Rekor',
      fontSet: 'fs',
    },
    dronesense: {
      fontIcon: 'Icon_DroneSense',
      fontSet: 'fs',
    },
    soundthinking: {
      fontIcon: 'Icon_ShotSpotter',
      fontSet: 'fs',
    },
  };

  constructor(public data: SnAlarm[], @Optional() public options?: any) {
    this._iconLayer = new IconLayer({
      id: 'fs__alarm-webgl-marker',
      data,
      getIcon: (d) => ({
        url: `/assets/fusus-icons/PNG/${this._getAlertIcon(d)}.png`,
        width: 24,
        height: 24,
        anchorY: 12,
        anchorX: 12,
      }),
      pickable: true,
      getPosition: (d) => d.geometry?.coordinates,
      getSize: () => 24,
      ...options,
    });
    this._scatterPlotLayer = new ScatterplotLayer({
      id: 'fs__scatterplot-layer',
      data,
      opacity: 0.5,
      stroked: 2.5,
      filled: true,
      radiusScale: 1,
      radiusMinPixels: 15,
      radiusMaxPixels: 15,
      pickable: true,
      lineWidthMinPixels: 2,
      lineWidthMaxPixels: 2,
      getPosition: (d) => d.geometry?.coordinates,
      getRadius: () => 15,
      getFillColor: () => THEME_RGB_ARR['fusus-dark'],
      getLineColor: (d) => THEME_RGB_ARR['fusus-dark'],
    });
  }

  public getLayer(): IconLayer {
    return this._iconLayer;
  }

  public getScatterplotLayer(): ScatterplotLayer {
    return this._scatterPlotLayer;
  }

  public getClusterMarkerLayer(): ScatterplotLayer {
    return this._scatterPlotLayer;
  }

  private _getAlertIcon(alarm: SnAlarm): any {
    let alertIcon;
    if (this._icons[alarm?.type?.toLowerCase()]) {
      alertIcon = this._icons[alarm.type.toLowerCase()].fontIcon;
      return alertIcon;
    }
    return 'Icon_GeneralAlert';
  }
}
